export enum AppRoutes {
	HOME = '/home',
	COMPANY_DATA = 'home/company-data',
	OTP = '/home/verify-phone',
	TAX_FOLDER = '/home/tax-folder',
	TAX_FOLDER_WARNING = '/home/tax-folder-warning',
	ERROR = '/error',
}

export enum ApiEndpoints {
	INITIAL_PARAMETERS = '/simulador-publico',
	VALIDATE = '/cliente/valida',
	CONSENT = '/carpeta-tributaria/consentimientos',
	REQUEST_TAX_FOLDER = '/carpeta-tributaria/solicitud',
	GENERATE_SEND_OTP = '/codigos-otp/generacion-envio',
	OTP_VALIDATION = '/codigos-otp/validacion',
}
